import { clearTimeout, setTimeout } from 'worker-timers';
import { Injectable } from '@angular/core';
import { AppEnvironmentState, Environment } from '../../../shared';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
export class InactivityService {
  store;
  destroyed;
  PROD_INACTIVITY_DURATION = 25 * 60 * 1000;
  OTHER_ENV_INACTIVITY_DURATION = 60 * 60 * 1000;
  timerId;
  isAdmin = false;
  duration;
  callbackMethod;
  constructor(store, destroyed) {
    this.store = store;
    this.destroyed = destroyed;
    this.duration = this.PROD_INACTIVITY_DURATION;
    this.store.select(AppEnvironmentState.appEnvironmentState).pipe(takeUntilDestroyed(this.destroyed)).subscribe(({
      environment
    }) => {
      if (environment && environment != Environment.PROD) {
        this.duration = this.OTHER_ENV_INACTIVITY_DURATION;
        this.startTimer();
      }
    });
  }
  setIsAdmin(isAdmin) {
    this.isAdmin = isAdmin;
    this.resetTimer();
  }
  setCallbackMethod(callback) {
    this.callbackMethod = callback;
    this.resetTimer();
  }
  startTimer() {
    this.clearTimer();
    if (this.isAdmin) return;
    this.timerId = setTimeout(() => {
      if (this.callbackMethod) {
        this.callbackMethod();
      } else {
        console.error('Callback method is not set.');
      }
    }, this.duration);
  }
  resetTimer() {
    this.startTimer();
  }
  clearTimer() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  }
  static ɵfac = function InactivityService_Factory(t) {
    return new (t || InactivityService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i0.DestroyRef));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: InactivityService,
    factory: InactivityService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InactivityService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.Store
  }, {
    type: i0.DestroyRef
  }], null);
})();
